var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "08-Birthday"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32a3 3 0 0 0 3-3c0-1.28-1.52-3.62-2.18-4.57a1 1 0 0 0-1.64 0C30.52 25.38 29 27.72 29 29a3 3 0 0 0 3 3Zm0-5.15A7.48 7.48 0 0 1 33 29a1 1 0 0 1-2 0 7.6 7.6 0 0 1 1-2.15ZM22 32a3 3 0 0 0 3-3c0-1.28-1.52-3.62-2.18-4.57a1 1 0 0 0-1.64 0C20.52 25.38 19 27.72 19 29a3 3 0 0 0 3 3Zm0-5.15A7.48 7.48 0 0 1 23 29a1 1 0 0 1-2 0 7.6 7.6 0 0 1 1-2.15ZM19 39h-2a3 3 0 0 0-3 3v13a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V42a3 3 0 0 0-3-3h-2v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5h-4v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5h-4v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Zm29 15H16v-7c.56 0 .8.22 1.29.71a3.49 3.49 0 0 0 5.42 0c.49-.49.73-.71 1.29-.71s.8.22 1.29.71a3.49 3.49 0 0 0 5.42 0c.49-.49.73-.71 1.29-.71s.8.22 1.29.71a3.49 3.49 0 0 0 5.42 0c.49-.49.73-.71 1.29-.71s.8.22 1.29.71a3.49 3.49 0 0 0 5.42 0c.49-.49.73-.71 1.29-.71Zm0-12v3a3.6 3.6 0 0 0-2.71 1.29c-.49.49-.73.71-1.29.71s-.8-.22-1.29-.71a3.49 3.49 0 0 0-5.42 0c-.49.49-.73.71-1.29.71s-.8-.22-1.29-.71a3.49 3.49 0 0 0-5.42 0c-.49.49-.73.71-1.29.71s-.8-.22-1.29-.71a3.49 3.49 0 0 0-5.42 0c-.49.49-.73.71-1.29.71s-.8-.22-1.29-.71A3.6 3.6 0 0 0 16 45v-3a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1Zm-7-7h2v4h-2Zm-10 0h2v4h-2Zm-8 0v4h-2v-4ZM42 32a3 3 0 0 0 3-3c0-1.28-1.52-3.62-2.18-4.57a1 1 0 0 0-1.64 0C40.52 25.38 39 27.72 39 29a3 3 0 0 0 3 3Zm0-5.15A7.48 7.48 0 0 1 43 29a1 1 0 0 1-2 0 7.6 7.6 0 0 1 1-2.15Z",
    fill: "#898686",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 7h-6V5a3 3 0 0 0-6 0v2h-6V5a3 3 0 0 0-6 0v2h-6V5a3 3 0 0 0-6 0v2h-6V5a3 3 0 0 0-6 0v2H5a3 3 0 0 0-3 3v15a1 1 0 0 0 2 0v-5h56v31a1 1 0 0 0 2 0V10a3 3 0 0 0-3-3ZM49 5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0ZM37 5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0ZM25 5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0ZM13 5a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0ZM4 18v-8a1 1 0 0 1 1-1h6v2a3 3 0 0 0 6 0V9h6v2a3 3 0 0 0 6 0V9h6v2a3 3 0 0 0 6 0V9h6v2a3 3 0 0 0 6 0V9h6a1 1 0 0 1 1 1v8ZM61 54a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V29a1 1 0 0 0-2 0v30a3 3 0 0 0 3 3h54a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1Z",
    fill: "#898686",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.5ff7f94d9b3af59714ad6ade8236fe75.svg";
export { ForwardRef as ReactComponent };